import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import Suggestions from "../components/view-products/suggestions";
import ProductsDesc from "../components/view-products/product-desc";
import EventsListing from "../components/view-products/events-listing";
import TabGroup from "../components/tab-group";
import Layout from "../layout/layout";
export default class ViewProducts extends React.Component {
    constructor(props) {
        super(props);
        this.capitalize = (x) => {
            if (x && x.length > 1) {
                return x[0].toUpperCase() + x.substr(1).toLowerCase();
            }
            else {
                return x;
            }
        };
    }
    render() {
        let product = this.props.product;
        const searchCat = this.capitalize(this.props.product.SearchCategory);
        let sectionRoute = searchCat === "Ciders & Coolers" || searchCat === "Cooler" || searchCat == "Cider" ? '/Products/Search?category=CIDERS%20%26%20COOLERS' : `/Products/Search?category=${this.props.product.SearchCategory == null ? "" : this.props.product.SearchCategory.toUpperCase()}`;
        let hasProductNotes = product.Review ||
            product.TastingNotes ||
            product.PairingNotes ||
            product.WinemakerOrBrewer ||
            product.AgentReviewNote ||
            product.AgentReviewSource ||
            product.WinePointValue;
        let tabObjs = [];
        if (hasProductNotes) {
            let ProductNotes = React.createElement("div", { className: "product-notes" },
                product.Review &&
                    React.createElement("div", { className: "product-section" },
                        React.createElement("span", { className: "header" }, "Product / Technical Review: "),
                        " ",
                        product.Review),
                product.TastingNotes &&
                    React.createElement("div", { className: "product-section" },
                        React.createElement("span", { className: "header" }, "Tasting Notes: "),
                        " ",
                        product.TastingNotes),
                product.PairingNotes &&
                    React.createElement("div", { className: "product-section" },
                        React.createElement("span", { className: "header" }, "Pairing Notes: "),
                        " ",
                        product.PairingNotes),
                product.WinemakerOrBrewer &&
                    React.createElement("div", { className: "product-section" },
                        React.createElement("span", { className: "header" }, "Winemaker/Brewer: "),
                        " ",
                        product.WinemakerOrBrewer),
                product.AgentReviewNote &&
                    React.createElement("div", { className: "product-section" },
                        React.createElement("span", { className: "header" }, "Agent Review Note: "),
                        " ",
                        product.AgentReviewNote),
                product.AgentReviewSource &&
                    React.createElement("div", { className: "product-section" },
                        React.createElement("span", { className: "header" }, "Agent Review Source: "),
                        " ",
                        React.createElement("a", { href: product.AgentReviewSource }, product.AgentReviewSource)),
                product.WinePointValue &&
                    React.createElement("div", { className: "product-section" },
                        React.createElement("span", { className: "header" }, "Wine Point Value: "),
                        " ",
                        product.WinePointValue || "0.00"));
            tabObjs = [
                { id: this.props.events.length > 0 ? 1 : 0, tabHeader: "Product Notes", tabContent: ProductNotes }
            ];
        }
        if (this.props.events.length > 0) {
            tabObjs.push({ id: 0, tabHeader: "Upcoming Tastings", tabContent: React.createElement(EventsListing, { events: this.props.events }) });
        }
        let NavList = [
            { Text: this.capitalize(this.props.product.SearchCategory), Link: sectionRoute },
            { Text: this.props.product.Name, Link: '' }
        ];
        return (React.createElement(Layout, { route: 'this.props.route' },
            React.createElement(Breadcrumb, { NavList: NavList }),
            React.createElement(ProductsDesc, { product: product }),
            tabObjs.length > 0 &&
                React.createElement(TabGroup, { tabObjs: tabObjs }),
            this.props.suggestions.length > 0 &&
                React.createElement(Suggestions, { suggestions: this.props.suggestions, loadingSuggestions: this.props.loadingSuggestions })));
    }
}
;
//# sourceMappingURL=view-products.js.map